<script lang="ts" setup>
import { InputSearch } from "@/components/Ui";
import { cards } from "../../config/timezone";
import { computed, reactive, ref } from "vue";
import { onDashboard } from "~/helpers/events";

const cardsReactive = reactive(cards);
const filterValue = ref("");

const numbersOnly = (str: string) => {
  return str.replace(/\D/g, "");
};

const filteredItems = computed(() => {
  return cards.filter((item) =>
    item.city.toLowerCase().includes(filterValue.value.toLowerCase()),
  );
});
</script>

<template>
  <div :class="$style.root">
    <div :class="`${$style[`time-wrapper`]} ${$style[`time-title-wrapper`]}`">
      <div class="flex flex-col gap-[10px]">
        <p :class="$style['time-title']">{{ $t("timezone.difference") }}</p>
        <p :class="$style['time-text']">{{ $t("timezone.and") }}</p>
      </div>
      <div class="w-full lg:w-96">
        <InputSearch v-model="filterValue" />
      </div>
    </div>
    <div :class="$style['time-display']">
      <div :class="$style['time-timezone']">
        <div
          :class="`${$style[`time-wrapper`]} ${$style[`time-link-wrapper`]}`"
        >
          <p :class="$style['time-link-title']">
            {{ $t("timezone.shopping") }}
          </p>
          <a
            :class="$style['time-link']"
            @click="onDashboard('', '/register', {}, {}, true)"
            >{{ $t("timezone.virtual") }}
          </a>
        </div>
        <div
          v-for="card in filteredItems"
          :key="card.id"
          :class="$style['time-wrapper']"
        >
          <p :class="$style['time-content']">{{ card.city }}</p>
          <p :class="$style['time-content']">{{ card.pst }} hour to PST</p>
        </div>
      </div>
      <div :class="$style.divider" />
      <div :class="$style['time-chart-wrapper']">
        <div :class="$style['time-schedule']">
          <span
            v-for="card in filteredItems"
            :key="card.id"
            :class="$style['time-chart']"
            :style="{ width: numbersOnly(card.pst) * 15 + 'px' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply flex flex-col w-full rounded-20 bg-gradient-to-r from-neutral-900 to-neutral-800;
  @apply mt-4 gap-[22px] sm:gap-[47px] pt-[30px] pb-[40px] px-[20px] sm:pt-[35px] sm:pb-[50px] sm:px-[50px];
}

.time {
  &-wrapper {
    @apply flex items-center justify-between w-full;
  }

  &-title {
    @apply font-semibold text-[24px] xxs:text-[29px] sm:text-[42px] xl:text-[47px] leading-[35px] sm:leading-[55px] text-white;
    &-wrapper {
      @apply flex-col lg:flex-row items-start lg:items-center gap-[22px];
    }
  }

  &-text {
    @apply font-normal text-[16px] xxs:text-[20px] sm:text-[22px] leading-[24px] sm:leading-[26px] text-white;
  }

  &-timezone {
    @apply flex items-center justify-between flex-col gap-[16px] w-full xl:w-[45%];
  }

  &-display {
    @apply flex;
  }

  &-content {
    @apply font-normal text-[14px] xxs:text-[16px] leading-[19px] text-white;
  }

  &-link {
    @apply font-medium text-[14px] xs:text-[16px] leading-[19px] cursor-pointer text-accent-primary text-right underline whitespace-nowrap;

    &-title {
      @apply font-semibold text-[16px] leading-[19px] text-accent-primary whitespace-nowrap mr-[70px];
    }

    &-wrapper {
      @apply flex items-start flex-col sm:flex-row gap-[8px];
    }
  }

  &-schedule {
    @apply mt-[32px] flex items-start flex-col gap-[15px];
  }

  &-chart {
    @apply h-[20px] rounded-[50px] bg-white;
    &-wrapper {
      @apply hidden xl:flex flex-col w-full;
    }
  }
}

.divider {
  @apply hidden xl:block  border-2 border-solid border-white my-0 mx-[40px];
}
</style>
